module.exports = __webpack_public_path__ + "static/media/tablet_icon.0abf745b.svg";